module.exports = __webpack_public_path__ + "img/image24.f392e261.png";